import React from 'react'

const Banner = ({ title }) => {
	return (
		<div
			style={{
				padding: '0 5px',
				width: '100%',
				backgroundColor: '#008E48',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			}}
			className='banner-title'
		>
			<h1
				style={{
					color: '#fff',
					textAlign: 'center',
					fontWeight: '500',
					display: 'flex',
					paddingTop: '18px',
					paddingBottom: '0px'
				}}
			>
				{title}
			</h1>
		</div>
	)
}

export default Banner
